import request from '@/utils/request'
export const checkData = (uu, type) => {
    return request.get('/index/avaiableAccessToken', {
        params: {
            token: uu,
            ty: type
        }
    })
}
export const checkGame = (uu, type) => {
    return request.get('/index/changeGame', {
        params: {
            token: uu,
            ty: type
        }
    })
}
export const searchData = (uu, type) => {
    return request.get('/index/checkCode', {
        params: {
            token: uu,
            ty: type
        }
    })
}
